import { Stack } from '@mui/material';

import { url } from '../../appRouter/url.js';
import { FailedQueryAlert } from '../../components/general/ErrorAlert.js';
import {
  ContentLoading,
  EasyBreadcrumbs,
  type EasyBreadcrumbsItem,
  NoContentInfo,
} from '../../components/general/index.js';
import { useNormalizedParams } from '../../hooks/useNormalizedParams.js';
import { usePageTitle } from '../../hooks/usePageTitle.js';
import { trpc } from '../../trpc.js';
import { isBlendedLearning } from '../../utils/index.js';
import { BlendedThema } from './BlendedLearning/BlendedThema.js';
import { Thema } from './Thema.js';

export const ThemaDetailsPage = () => {
  const { akaProduktId } = useNormalizedParams();

  if (akaProduktId === undefined) {
    throw new TypeError('Die Aka-Produkt-Id fehlt in der URL.');
  }

  const themaQuery = trpc.thema.getThemaByAkaProduktId.useQuery(akaProduktId);

  usePageTitle(themaQuery.data && `${themaQuery.data.thema.buchungsnummer} | Thema`);

  if (themaQuery.error && themaQuery.error.data?.code !== 'NOT_FOUND') {
    return <FailedQueryAlert error={themaQuery.error} query="Thema" />;
  }

  if (themaQuery.isLoading) {
    return <ContentLoading />;
  }

  const thema = themaQuery.data?.thema;

  if (!thema) {
    return <NoContentInfo content="Kein Thema gefunden" />;
  }

  const breadcrumbs: EasyBreadcrumbsItem[] = [
    {
      href: url.root(),
      label: 'Dashboard',
    },
    {
      href: '',
      label: 'Thema',
    },
  ];

  if (isBlendedLearning(thema.strukturellesFormat)) {
    return (
      <Stack sx={{ mt: 2, mb: 45 }}>
        <EasyBreadcrumbs items={breadcrumbs} />
        <BlendedThema thema={thema} />
      </Stack>
    );
  } else {
    return (
      <Stack sx={{ mt: 2, mb: 45 }}>
        <EasyBreadcrumbs items={breadcrumbs} />
        <Thema thema={thema} />
      </Stack>
    );
  }
};
